import { useGetData } from '../../api/api-tools';

export const useWorkshopsByOrganization = (organizationId) => {
  const queryKey = `workshops_organization:${organizationId}`;
  const query = `workshops?organization=${organizationId}`;
  const { data } = useGetData(queryKey, query, {}, !!organizationId);

  return data;
};
